import { render } from "./legoDashboardArea.vue?vue&type=template&id=7d5095a0"
import script from "./legoDashboardArea.vue?vue&type=script&lang=js"
export * from "./legoDashboardArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoArea/legoDashboardArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d5095a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d5095a0', __exports__)) {
    api.reload('7d5095a0', __exports__)
  }
  
  module.hot.accept("./legoDashboardArea.vue?vue&type=template&id=7d5095a0", () => {
    api.rerender('7d5095a0', render)
  })

}


export default __exports__